<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-card-title>
          Please Log in!
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
            label="Name"
            v-model="name"
            :rules="nameRules"
            :counter="10"
            required>
            </v-text-field>
            <v-text-field
            label="Password"
            v-model="password"
            :rules="passwordRules"
            type="password"
            required>
          </v-text-field>
            <v-btn
              success
              :disabled="!valid"
              @click="login">
              Log in
            </v-btn>
          </v-form>
          <v-alert v-model="loginProblem" error dismissible icon="warning" value="true">
           Your username or password is incorrect!
         </v-alert>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      valid: true,
      loginProblem: false,
      name: '',
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 10 || 'Name must be less than 10 characters'
      ],
      password: '',
      passwordRules: [
        (v) => !!v || 'Password is required'
      ]
    }
  },
  methods: {
    login: function () {
      if (this.$refs.form.validate()) {
        var self = this
        this.loginProblem = false
        this.$auth.login(this, this.name, this.password, function (response) {
          self.$router.push('/')
        }, function (error) {
          self.loginProblem = true
          console.log(error)
        })
      }
    }
  }
}
</script>

<style scoped>
  .card__title {
    background: #2196f3;
    font-weight: bold;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?0744eb4b